"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditUserForm = void 0;
const React = __importStar(require("react"));
const useForm_1 = require("@hooks/useForm");
require("./styles.scss");
const button_1 = require("@components/button");
const user_hooks_1 = require("@hooks/user.hooks");
const text_input_1 = require("@components/text-input");
const EditUserForm = (props) => {
    var _a;
    const { user, onClose } = props;
    const updateUser = (0, user_hooks_1.useUserUpdater)();
    const { form, fieldHandlers, validationResults, submit } = (0, useForm_1.useForm)({
        initialData: {
            referralRate: (_a = user.referralRate) === null || _a === void 0 ? void 0 : _a.toString(),
        },
        submit: (form, validationResults) => __awaiter(void 0, void 0, void 0, function* () {
            if (validationResults.isValid) {
                yield updateUser({
                    referralRate: Number(form.referralRate),
                    wallet: user.wallet,
                });
                onClose();
            }
        }),
    });
    return (React.createElement("div", { className: "c-user-form" },
        React.createElement(text_input_1.TextInput, { label: "Referral Rate", type: "positiveNumber", value: form.referralRate, onChangeValue: fieldHandlers.referralRate, error: validationResults.results.referralRate }),
        React.createElement("div", { className: "c-user-form__buttons" },
            React.createElement(button_1.Button, { type: "secondary", onClick: submit }, "Edit"),
            React.createElement(button_1.Button, { type: "secondary", onClick: onClose }, "Cancel"))));
};
exports.EditUserForm = EditUserForm;
